import { API, graphqlOperation } from "aws-amplify";
import { updateLLMMemory } from "../graphql/mutations";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { UpdateLLMMemoryMutation, UpdateLLMMemoryInput } from "../API";

export async function updateLLMMemoryAfterEdit(
  input: UpdateLLMMemoryInput
): Promise<GraphQLResult<UpdateLLMMemoryMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMMemory, {
      input: input,
    })
  ) as Promise<GraphQLResult<UpdateLLMMemoryMutation>>;
}
